/**
 * Enum for describing styles of a link to indicate its visual importance or role.
 */
export var VisualStyle;
(function (VisualStyle) {
    VisualStyle["Default"] = "default";
    VisualStyle["Highlighted"] = "highlighted";
    VisualStyle["Underlined"] = "underlined"; // Always underlined, regardless of state or interaction.
})(VisualStyle || (VisualStyle = {}));
//# sourceMappingURL=VisualStyle.js.map